var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyus10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-5 {\n        fill: #e0ef4d;\n      }\n\n      .cls-5, .cls-6, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.75,
    cy: 192.03,
    r: 53.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 195.28,
    cy: 105.5,
    r: 53.84
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 108.75,
    cy: 181.11,
    r: 16.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.12,231.66c0-18.57,15.05-33.62,33.62-33.62s33.62,15.05,33.62,33.62v22.09H75.12v-22.09Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 108.75,
    cy: 192.03,
    r: 53.84
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 195.28,
    cy: 94.57,
    r: 16.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.66,145.13c0-18.57,15.05-33.62,33.62-33.62s33.62,15.05,33.62,33.62v22.09h-67.24v-22.09Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 195.28,
    cy: 105.5,
    r: 53.84
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "219.45 190.87 235.61 174.7 251.77 190.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.61,174.7h0c0,36.31-29.43,65.74-65.74,65.74h0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "84.57 106.66 68.41 122.82 52.25 106.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.41,122.82h0c0-36.31,29.43-65.74,65.74-65.74h0"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.5,148.31c0,3.27-2.65,5.92-5.92,5.92h-55.29c-3.27,0-5.92-2.65-5.92-5.92,0-1.28,.42-2.53,1.18-3.55l4.74-6.32v-25.28c0-.19,0-.38,0-.58,.27-11.49,8.47-21.26,19.74-23.51h15.8c5.57,1.11,10.58,4.12,14.18,8.51,.38,.46,.74,.94,1.08,1.43,2.92,4.14,4.49,9.08,4.49,14.15v25.28l4.74,6.32c.77,1.03,1.19,2.27,1.18,3.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239.03,89.07l-3.95-13.82h23.7l-3.95,13.82h-15.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 238.64,
    cy: 113.06,
    r: 5.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 255.21,
    cy: 129.64,
    r: 5.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 235.47,
    y1: 132.8,
    x2: 258.38,
    y2: 109.9
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.01,241.14c0,3.27-2.65,5.92-5.92,5.92H31.79c-3.27,0-5.92-2.65-5.92-5.92,0-1.28,.42-2.53,1.18-3.55l4.74-6.32v-25.28c0-.19,0-.38,0-.58,.27-11.49,8.47-21.26,19.74-23.51h15.8c5.57,1.11,10.58,4.12,14.18,8.51,.38,.46,.74,.94,1.08,1.43,2.92,4.14,4.49,9.08,4.49,14.15v25.28l4.74,6.32c.77,1.03,1.19,2.27,1.18,3.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.54,181.9l-3.95-13.82h23.7l-3.95,13.82h-15.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 51.15,
    cy: 205.9,
    r: 5.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 67.72,
    cy: 222.47,
    r: 5.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 47.98,
    y1: 225.64,
    x2: 70.89,
    y2: 202.73
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus10);
export default __webpack_public_path__ + "static/media/whyus10.4363e25be96bd97ea33563ca463641eb.svg";
export { ForwardRef as ReactComponent };